<template>
  <div>
    <div class="con-tab-ejemplo">
      <vs-list>
        <vs-list-header></vs-list-header>
        <vs-list-item v-for="res in sendDocHistories" :key="res.id" :title="`${convFormatSeq(res.seq)} ${convFormatDateTime(res.sendDate)}`" :subtitle="`${res.remark}`">
          <vs-button class="btn-icon" size="small" color="danger" v-show="!isHideDelSendDocHistory(res)" @click="delSendDocHistory(res.id)">ลบ</vs-button>
        </vs-list-item>
        <div class="mt-2">
          <vs-textarea class="w-full mt-2 mb-2" v-model="form.sendDocHistory.remark" rows="5"/>
          <vs-button class="btn-icon" size="small" color="success" @click="addSendDocHistory()">เพิ่มข้อมูล</vs-button>
        </div>
      </vs-list>
    </div>
  </div>
</template>

<script>
import moment from 'moment/moment';
import {createNamespacedHelpers} from 'vuex'
const { mapActions: mapAccountingActions, mapState: mapAccountingState} = createNamespacedHelpers('Accounting');

export default {
  data () {
    return {
      form:{
        sendDocHistory:{
          remark: ""
        }
      }
    }
  },
  computed:{
    ...mapAccountingState([
      'status',
      'contract',
      'sendDocHistories',
    ])
  },
  methods: {
    ...mapAccountingActions([
      'createSendDocHistory',
      'deleteSendDocHistory',
    ]),
    // Function SendDocHistory
    isHideDelSendDocHistory (res){
      if( res.seq >= this.sendDocHistories.length){
        return false
      }
      return true
    },
    async addSendDocHistory(){
      await this.createSendDocHistory({
        contractId: this.contract.id,
        form: {
          remark: this.form.sendDocHistory.remark,
        },
        vm: this
      })
      this.form.sendDocHistory.remark = ""
    },
    async delSendDocHistory(id){
      const vm = this
      vm.actionID = id
      vm.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: vm.$t('notification.confirm-delete-title'),
        text: vm.$t('notification.confirm-delete-message'),
        accept: vm.acceptDelSendDocHistory
      })
    },
    async acceptDelSendDocHistory () {
      await this.deleteSendDocHistory({
        form: {
          id: this.actionID
        },
        vm: this
      })
    },
    convFormatSeq(val){
      return `ครั้งที่ ${val}`
    },
    convFormatDateTime(val){
      return `${moment(val).format("วันที่ DD-MM-YYYY เวลา HH.mm น.")}`
    }
  },
}
</script>

<style scoped>
  .vx-coll-fixed-hight{
    display:block;
    width:100%;
    height:400px;
    overflow: auto;
  }
</style>
